import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "../lib/api";

export default function EnquiryForm({ artwork, enabled }) {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  if (!enabled) return null;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await api.post("/enquiries", { artwork_id: artwork.id, ...form });
      toast.success("Enquiry sent — the studio replies personally");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err, "Could not send the enquiry — please try again"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="enquiry-section" className="mt-8">
      <div className="flex items-center gap-3 mb-4">
        <span className="h-px flex-1 bg-line" />
        <p className="eyebrow flex items-center gap-2">
          <Mail size={11} /> Ask about this piece
        </p>
        <span className="h-px flex-1 bg-line" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input
          required
          placeholder="Your name"
          className="field-input"
          data-testid="enquiry-name-input"
          value={form.name}
          onChange={set("name")}
        />
        <input
          required
          type="email"
          placeholder="Your email"
          className="field-input"
          data-testid="enquiry-email-input"
          value={form.email}
          onChange={set("email")}
        />
      </div>
      <textarea
        required
        rows={3}
        placeholder="Your message — shipping, dimensions, anything at all"
        className="field-input mt-3 resize-y"
        data-testid="enquiry-message-input"
        value={form.message}
        onChange={set("message")}
      />
      <button
        type="submit"
        disabled={busy}
        data-testid="enquiry-submit-button"
        className="mt-3 w-full border border-gold/60 bg-transparent text-gold font-meta text-[11px] uppercase tracking-[0.3em] py-3.5 hover:bg-gold hover:text-ink transition-colors duration-300 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {busy ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
}
